import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { ISiteOIDCConfiguration } from '../types/ISiteOIDCConfiguration';

export interface ICreateOrUpdateSiteOIDCConfigurationParams {
  siteOIDCConfiguration: ISiteOIDCConfiguration;
}

export class CreateOrUpdateSiteOIDCConfigurationRequest extends Request<ICreateOrUpdateSiteOIDCConfigurationParams, IResult> {
  constructor(params: ICreateOrUpdateSiteOIDCConfigurationParams) {
    super('createOrUpdateSiteOIDCConfiguration', params);
  }
}
